<template>
  <div v-wechat-title="$route.meta.title">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner :locale="locale" title="fzlc"></common-banner>
    <common-title :cn="$t('txt.fzlc')" style="margin-top: 50px;"></common-title>
    <div class="timeline">
      <div v-for="(event, index) in items" :key="index" class="timeline-item">
        <div class="timeline-dot"></div>
        <div class="timeline-content">
          <h3 class="timeline-date">{{ event.year }}</h3>
          <p class="timeline-title" v-html="event.desc"></p>
          <img
            v-if="[5].includes(index)"
            class="timeline-img"
            :src="event.image"
            alt=""
            style="left:-200px"
          />
          <img
            v-if="[4, 8].includes(index)"
            class="timeline-img"
            :src="event.image"
            alt=""
            style="left:-150px"
          />
          <img
            v-else
            class="timeline-img"
            :src="event.image"
            alt=""
            style="left:-300px"
          />
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonTitle from "./components/Common/Title";
import CommonBanner from "./components/Common/Banner";
import history02 from "../assets/images/history02.jpg";
import history03 from "../assets/images/history03.jpg";
import history04 from "../assets/images/history04.jpg";
import history05 from "../assets/images/history05.jpg";
import history06 from "../assets/images/history06.jpg";
import history07 from "../assets/images/history07.jpg";
import history08 from "../assets/images/history08.jpg";
import history09 from "../assets/images/history09.jpg";

export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonNav,
    CommonHeader,
    CommonTitle,
    CommonFooter,
    CommonBanner
  },
  data() {
    return {
      detail: "",
      id: "西河创立\n第一款开口铆钉走上生产线",
      items: [],
      locale: "zh-cn"
    };
  },
  created() {
    let _router = this.$route;
    this.id = _router.params.id;
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/about/history",
          {},
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.items = res.data.data;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.timeline {
  position: relative;
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding: 0.2rem 0;
}

.timeline::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background-color: #000;
  left: 30%;
}

.timeline-item {
  position: relative;
  margin-bottom: 0.2rem;
  min-height: 150px;
}

.timeline-dot {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fd8204;
  border-radius: 50%;
  top: 10%;
  left: 30%;
  transform: translate(-50%, -50%);
}

.timeline-content {
  position: relative;
  left: 30%;
  width: 40%;
  margin-left: 0.15rem;
  padding: 0.1rem;
  border-radius: 8px;
  .timeline-date {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .timeline-title {
    font-size: 16px;
    line-height: 25px;
    color: #ccc;
    white-space: pre;
    margin-bottom: 0.1rem;
  }
  .timeline-subTitle {
    font-size: 16px;
    color: #ccc;
  }
  .timeline-img {
    position: absolute;
    left: -300px;
    top: 30%;
  }
}
@media screen and (max-width: 750px) {
  .timeline::before {
    left: 50%;
  }
  .timeline-dot {
    left: 50%;
  }
  .timeline-content {
    left: 50%;
  }
  .timeline-img {
    left: -180px !important;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fzlc.vue